import { call } from 'redux-saga/effects';

import { RequestError } from './httpUtil';
import { isTokenValid } from './jwt';

import store from '../store';

export function* callHttp(...args) {
  if (process.env.REACT_APP_MOCK) return;

  try {
    const token = store.getState().auth.token;

    if (!isTokenValid(token)) {
      throw new RequestError(401);
    }

    const data = yield call(...args, !!token);
    return data;
  } catch (err) {
    throw err;
  }
}
